export default "__VITE_ASSET__CwLMhiG4__"